export const addValueIfExists = (key: string, value: any) => {
  return value ? { [key]: value } : {};
};
